var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"poke-type-badge",class:[_vm.bgColor]},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.translatedType))])])}
var staticRenderFns = []

export { render, staticRenderFns }